import { buttonsFromSerializedInAppMessage as pe } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class FullScreenMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    a,
    o,
    p,
    m,
    n,
    u,
    c,
    f,
    d,
    l,
    g,
    j,
    x,
    z,
    h,
    v,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
    B,
  ) {
    (p = p || InAppMessage.DismissType.MANUAL),
      (k = k || InAppMessage.Orientation.PORTRAIT),
      super(
        e,
        r,
        void 0,
        s,
        t,
        i,
        a,
        o,
        p,
        m,
        n,
        u,
        c,
        f,
        d,
        l,
        g,
        j,
        x,
        z,
        h,
        v,
        w,
        y,
        S,
        (b = b || InAppMessage.CropType.CENTER_CROP),
        k,
        q,
        A,
        B,
      ),
      (this.$o = InAppMessage.TextAlignment.CENTER);
  }
  bt() {
    return super.bt(FullScreenMessage.cs);
  }
  static Qr(e) {
    return new FullScreenMessage(
      e[InAppMessage.es.ra],
      e[InAppMessage.es.sa],
      e[InAppMessage.es.qs],
      e[InAppMessage.es.ta],
      e[InAppMessage.es.ia],
      e[InAppMessage.es.URI],
      e[InAppMessage.es.oa],
      e[InAppMessage.es.pa],
      e[InAppMessage.es.ma],
      e[InAppMessage.es.na],
      e[InAppMessage.es.ls],
      e[InAppMessage.es.ua],
      e[InAppMessage.es.ca],
      e[InAppMessage.es.fa],
      e[InAppMessage.es.da],
      e[InAppMessage.es.la],
      e[InAppMessage.es.ga],
      e[InAppMessage.es.ja],
      e[InAppMessage.es.xa],
      e[InAppMessage.es.za],
      e[InAppMessage.es.ha],
      e[InAppMessage.es.va],
      e[InAppMessage.es.wa],
      pe(e[InAppMessage.es.ya]),
      e[InAppMessage.es.Sa],
      e[InAppMessage.es.ba],
      e[InAppMessage.es.ka],
      e[InAppMessage.es.CSS],
      e[InAppMessage.es.qa],
    );
  }
}
FullScreenMessage.cs = InAppMessage.bo.Lr;
